import styled from 'styled-components';

export const Step = styled.li`
  margin-bottom: 30px;

  @media only screen and (min-width: 900px) {
  margin-bottom: 100px;
  }
`;

export const StepTitle = styled.h3`
  margin: 0;
  padding: 0;
  padding-left: ${p => (p.hasIcon ? '12px' : 0)};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SquareBadge = styled.span`
  border-radius: 3px;
  border: black solid 2px;
  background-color: #efefef;
  padding: 5px;
  font-family: 'Montserrat', 'Open Sans', sans-serif;
  font-weight: bold;
  height: ${p => p.size || null};
  width: ${p => p.size || null};
  display: flex;
  justify-content: center;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/Step/styles.js